import React, { useState } from 'react';
import { Button, Modal, Form, Input, InputNumber, DatePicker } from 'antd';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';
import { Link } from 'react-router-dom';

function AddStage(props) {
    const [form] = Form.useForm();
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [isActive,setIsActive] = useState(false);

    function toggleModal() {
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
        setIsActive(false);
        form.resetFields();
    }
    
    async function onFinish(values) {
        // values.stageId = props.seasonId
        // console.warn('values della form: ', values)
        const stringDate = values.date.format('YYYY-MM-DDTHH:mm:ssZ')
        values.date = stringDate
        values.round = 1;
        
        setConfirmLoading(true);
        // TODO: se round è 0 o undefined, mettiamo round a 1, altrimenti si blocca tutto. 
        // In futuro, se vogliamo permettere di inserire round diversi da 1, dobbiamo gestire meglio questo aspetto.
        /* if (values.round === undefined || values.round === null || values.round === '' || values.round === 0) {
            values.round = 1;
        } */
        
        const response = await fetch(api.stages().create(props.seasonId).href, {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(values) // body data type must match "Content-Type" header
        })
        .then((data) => data.json())

        window.location.reload(false);
    }

    const linkAddStageAdvanced = "/seasons/"+props.seasonId+"/addstage";

    return(
            <div>
                <Modal title="Add stage" open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} confirmLoading={confirmLoading} cancelText="Cancel" okText="Generate">
                    <Link to={linkAddStageAdvanced}>Click here to add a stage in advanced mode</Link>
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }}>
                    <Form.Item label="Stage Name" name="name">
                        <Input placeholder="Nome" />
                    </Form.Item>
                    <Form.Item label="Date" name="date">
                        <DatePicker placeholder="Data Tappa" format="DD/MM/YYYY" />
                    </Form.Item>
                    <Form.Item label="Stage Number" name="stageNumber" rules={[{ required: true, message: 'Stage number required!'}]}>
                        <InputNumber placeholder='Stage Nr.' />
                    </Form.Item>
                    <Form.Item label="Leg Number" name="round" style={{ display: 'none' }}>
                        <InputNumber placeholder='Leg Number' />
                    </Form.Item>
                    <Form.Item label="Swiss Rounds" name="turns">
                        <InputNumber min={3} max={10} placeholder='Rounds' />
                    </Form.Item>
                </Form>
                </Modal>
                <Button style={{ marginTop: 16 }} type="primary" onClick={toggleModal}>
                    ADD STAGE
                </Button>
            </div>
    )
}

export default AddStage;